/** Percorsi in public/ per le icone monete (vista griglia). WFRP: d/s/gc riusano bronzo/argento/oro. */
export const COIN_ICON_PATHS = {
  cp: "/icons/coins/cp.png",
  sp: "/icons/coins/sp.png",
  ep: "/icons/coins/ep.png",
  gp: "/icons/coins/gp.png",
  pp: "/icons/coins/pp.png",
  d: "/icons/coins/cp.png",
  s: "/icons/coins/sp.png",
  gc: "/icons/coins/gp.png",
};

export function getCoinIconUrl(currencyId) {
  const path = COIN_ICON_PATHS[currencyId];
  if (!path) return null;
  const base = process.env.PUBLIC_URL || "";
  return `${base}${path}`;
}
